var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-rounded-full tw-ml-2 tw-bg-ublue-100 tw-text-ublue-700 tw-text-xs tw-leading-4.5 tw-inline-block tw-text-center tw-min-w-5 tw-p-0.5"},[_vm._v("\n  "+_vm._s(_vm.counter > 99 ? "9+" : _vm.counter)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }